import { Approval } from '@cube3/common/model/schema/resources/approval';
import React, { useCallback } from 'react';
import { HBox } from '../../templates/layout/Flex';
import { ReviewStatusType, Status } from '../Status/Status';
import { Typography } from '../Typography';
import { capitalize } from '@material-ui/core';

export const DataSectionApproval = ({
  status = 'pending',
  onClick
}: {
  status: ReviewStatusType;
  onClick?: () => void;
}) => {
  const handleClick = useCallback(
    (e) => {
      // Used to prevent the default click event from being triggered
      e.stopPropagation();
      if (onClick) {
        onClick();
      }
    },
    [onClick]
  );
  return (
    <HBox
      gap={8}
      align="center"
      justify="start"
      onClick={handleClick}
      style={{ cursor: onClick ? 'pointer' : 'default', width: '100%' }}
    >
      <Status status={status} />
      <Typography variant="md" colorVariant="01">
        {capitalize(status)}
      </Typography>
    </HBox>
  );
};
